import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '../components/Mobile/contexts/LanguageContext';

const options = {
  useSuspense: false
};

const useLanguage = () => {
  const context = useLanguageContext();
  const { t, i18n, ready } = useTranslation('mobile', options);

  return {
    ...context,
    t,
    i18n,
    isReady: context.isReady && ready
  };
};

export default useLanguage;
